import type { ServerStatus } from '@panel/shared';

type Status = ServerStatus | 'unknown';

interface Props {
  status: Status;
  className?: string;
}

const LABELS: Record<string, string> = {
  online: 'Online',
  offline: 'Offline',
  starting: 'Starting',
  restarting: 'Restarting',
  updating: 'Updating',
  wiping: 'Wiping',
  unknown: '—',
};

const TONE: Record<string, string> = {
  online:     'bg-status-online/12 text-status-online ring-1 ring-status-online/25',
  offline:    'bg-bg-raised text-fg-muted ring-1 ring-bg-border',
  starting:   'bg-status-updating/12 text-status-updating ring-1 ring-status-updating/25',
  restarting: 'bg-status-warn/12 text-status-warn ring-1 ring-status-warn/25',
  updating:   'bg-status-updating/12 text-status-updating ring-1 ring-status-updating/25',
  wiping:     'bg-status-warn/12 text-status-warn ring-1 ring-status-warn/25',
  unknown:    'bg-bg-raised text-fg-muted ring-1 ring-bg-border',
};

export default function StatusPill({ status, className = '' }: Props) {
  const tone = TONE[status] ?? TONE.unknown;
  const label = LABELS[status] ?? status;
  return (
    <span className={`pill status-${status} ${tone} ${className}`}>
      <span className="dot" />
      {label}
    </span>
  );
}
